import * as React from "react";
const SvgCheckBoxOutline = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.872 12v10.128h20.256V1.872H1.872V12Zm1.507 0v8.62H20.62V3.38H3.38V12Z", fill: "currentColor" })));
export default SvgCheckBoxOutline;
